// extracted by mini-css-extract-plugin
export var contentWrapper = "heroHeaderImage-module--contentWrapper--cb096";
export var description = "heroHeaderImage-module--description--22ff0";
export var image = "heroHeaderImage-module--image--06b1b";
export var shadow = "heroHeaderImage-module--shadow--a7221";
export var title = "heroHeaderImage-module--title--b2c07";
export var wrapper = "heroHeaderImage-module--wrapper--0d02c";